export default "__VITE_PUBLIC_ASSET__74b45d6a__"